import type { Message } from 'services/types/message';

const BASE_MESSAGE = {
  clientId: -1,
  templateName: null,
  fileName: null,
  fileUrl: null,
  error: null,
  senderPhone: null,
  senderPhoneId: null,
  recipientPhone: null,
  recipientPhoneId: null,
  timestamp: null,
  mediaId: null,
  emoji: null,
  buttons: null,
  functionName: null,
  functionArguments: null,
  prompt: null,
  conversation: null,
  AIUsage: null,
  AIModel: null,
  functions: null,
  AIcost: 0,
  whatsAppCost: 0,
  cost: 0,
  url: null,
};

export const GREETING_MESSAGE_ID = 0;
export const PENDING_MESSAGE_ID = -1;

// Rendered client-side only: the greeting is copy, not a stored message, so it always opens the
// conversation. The epoch date keeps it first in the timeline, which sorts by createdAt.
export const buildGreetingMessage = (text: string): Message => ({
  ...BASE_MESSAGE,
  id: GREETING_MESSAGE_ID,
  createdAt: new Date(0),
  updatedAt: new Date(0),
  messageId: 'widget-greeting',
  status: 'sent',
  role: 'assistant',
  sender: 'system',
  text,
});

// Shows the visitor's message immediately, before the backend echoes it back.
export const buildPendingMessage = (text: string): Message => ({
  ...BASE_MESSAGE,
  id: PENDING_MESSAGE_ID,
  createdAt: new Date(),
  updatedAt: new Date(),
  messageId: 'widget-pending',
  status: 'sent',
  role: 'user',
  sender: 'client',
  text,
});
